import { Link, useLocation } from 'react-router-dom';
import { testClubInvitation, testClubPlacements } from './testClubInvitation';
import './TestClubInvitation.css';

export default function TestClubInvitation() {
  const { pathname } = useLocation();
  const placement = testClubPlacements[pathname];
  if (!placement) return null;
  return <aside className="test-club-invitation" aria-label="Try a test club">
    <Link to={testClubInvitation.href} data-test-club-cta={placement}>
      {testClubInvitation.label}<span aria-hidden="true"> →</span>
    </Link>
    <p>{testClubInvitation.description}</p>
  </aside>;
}
